var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.411,
    height: 17.137,
    viewBox: "0 0 23.411 17.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29424",
    "data-name": "Path 29424",
    d: "M11.8,12.886,10.186,14.5a.752.752,0,0,1-.549.234.735.735,0,0,1-.544-.234.786.786,0,0,1,0-1.12l2.942-2.968a.755.755,0,0,1,1.094,0L16.1,13.38a.755.755,0,0,1,0,1.094.786.786,0,0,1-1.12,0l-1.614-1.588V19.6h6.275a2.835,2.835,0,0,0,2-4.843,2.733,2.733,0,0,0-2-.833H18V11.74a5.6,5.6,0,0,0-1.575-3.983A5.143,5.143,0,0,0,12.529,6.09,5.184,5.184,0,0,0,8.623,7.757,5.572,5.572,0,0,0,7.035,11.74H6.54a3.7,3.7,0,0,0-2.734,1.133,3.995,3.995,0,0,0,.024,5.572A3.739,3.739,0,0,0,6.593,19.6H9.456a.754.754,0,0,1,.557.226.762.762,0,0,1,.224.56.747.747,0,0,1-.224.555.762.762,0,0,1-.557.221H6.593a5.26,5.26,0,0,1-3.853-1.614A5.26,5.26,0,0,1,1.125,15.7a5.433,5.433,0,0,1,1.289-3.58,5.2,5.2,0,0,1,3.32-1.862A7.058,7.058,0,0,1,8.181,6.129a6.761,6.761,0,0,1,4.452-1.6A6.494,6.494,0,0,1,17.567,6.65a7.176,7.176,0,0,1,1.992,5.09v.625a4.212,4.212,0,0,1,3.176,1.211,4.255,4.255,0,0,1,1.3,3.189,4.445,4.445,0,0,1-4.4,4.4H13.362A1.6,1.6,0,0,1,11.8,19.6Z",
    transform: "translate(-0.875 -4.278)",
    fill: "#ff5c35",
    stroke: "#f3f9fe",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.475c5b665a16fa7c3d4cf8046e642d78.svg";
export { ForwardRef as ReactComponent };